import { DEFAULT_DISTANCE_FROM_CONTAINER } from "../constants.js";
import { adjustLaterallyIfNeeded, adjustVerticallyIfNeeded, defaultPositionAdjustmentIfOverflowsVertically, getIdealBoundingRect, getIdealPositon, isLateralPositionAndOverflowing } from "./utils.js";
const getIdealPosition = (position, offset = DEFAULT_DISTANCE_FROM_CONTAINER)=>{
    const idealPosition = {
        newPosition: position
    };
    const idealPositionWithOffset = getIdealPositon(offset);
    if ('bottom' === position) return {
        ...idealPosition,
        top: idealPositionWithOffset
    };
    if ('top' === position) return {
        ...idealPosition,
        bottom: idealPositionWithOffset
    };
    if ('left' === position) return {
        ...idealPosition,
        right: idealPositionWithOffset
    };
    if ('right' === position) return {
        ...idealPosition,
        left: idealPositionWithOffset
    };
    return idealPosition;
};
const adjustPosition = ({ content, container, position, offset })=>{
    const idealRect = getIdealBoundingRect({
        container,
        content,
        position
    });
    if (isLateralPositionAndOverflowing(position, idealRect)) return adjustPosition({
        content,
        container,
        position: 'top'
    });
    const idealPosition = getIdealPosition(position, offset);
    if ('top' === position || 'bottom' === position) return {
        ...idealPosition,
        ...adjustLaterallyIfNeeded(idealRect),
        ...defaultPositionAdjustmentIfOverflowsVertically(idealRect, offset)
    };
    return {
        ...idealPosition,
        ...adjustVerticallyIfNeeded(idealRect)
    };
};
export { adjustPosition, getIdealPosition };
